import axios from 'axios';
import { environment as env, environment } from '../../environments/environment';
import { api as apiExports } from '../api';

const { Interceptor: api, routes } = apiExports;

export const contract_master_listing = async () => {
    return await api.get(`${routes?.fuel_management?.contractorMaster}?contractorType=FUEL`);
};

export const fuel_tank_master = async (params) => {
    return await api.get(`${routes?.fuel_management?.fuelTankMaster}${params ? `?${new URLSearchParams(params)}` : ''}`);
};

export const fuel_tank_master_unique = async () => {
    return await api.get(`${routes?.fuel_management?.fuelTankMasterUnique}`);
};

export const calculate_gallons_amt = async ({ SrvcGalType, start_date, end_date }) => {
    return await api.get(`${routes?.fuel_management?.calulate_gallons_amt}?SrvcGalType=${SrvcGalType}&start_date=${start_date}&end_date=${end_date}`);
};
export const calculate_gallons_amt_fuel_management = async (params) => {
    return await api.get(`${routes?.fuel_management?.calulate_gallons_amt + params}`);
};

export const create_fuel_tank_event = async (payload) => {
    return await api.post(`${routes?.fuel_management?.fuel_tank_event}`, payload);
};

export const update_fuel_tank_event = async (id, payload) => {
    return await api.put(`${routes?.fuel_management?.fuel_tank_event}/${id}`, payload);
};

export const get_fuel_tank_event = async (id) => {
    return await api.get(`${routes?.fuel_management?.fuel_tank_event}/${id}`);
};

export const create_fuel_tank_reading = async (payload) => {
    return await api.post(`${routes?.fuel_management?.fuel_tank_reading}`, payload);
};

export const get_fuel_tank_events = async (params) => {
    let queryParams = new URLSearchParams()
    if (![""]?.includes(params?.BOL)) queryParams?.append("BOL", params?.BOL)
    if (![""]?.includes(params?.InvNbr)) queryParams?.append("InvNbr", params?.InvNbr)
    return await api.get(routes?.fuel_management?.fuel_tank_event + "?" + queryParams.toString());
};

export const get_locomotive_fuel_tank = async (payload) => {
    return await api.post(`${routes?.fuel_management?.fuel_management_locomotive}`, payload)
}


export const update_locomotive_fuel_tank = async (payload) => {
    return await api.put(`${routes?.fuel_management?.crtDate_update}`, payload);
};
